import React from 'react';
import { LevelType } from 'types/data/level';
import PropTypes from 'prop-types';

import { Container } from './styles';
import InfoLogLevel from 'components/molecules/containers/InfoLogLevel';

const Level5LevelModal = ({ level, levelConquered }) => {
    const data = [
        {
            active: levelConquered,
            title: 'Matriz SWOT',
            url: 'https://forms.gle/qzbhtZxmRB7eu5rbA',
            target: '_blank'
        },
        {
            active: levelConquered,
            title: 'PDI',
            url: 'https://forms.gle/igEaErnp6HcWpACDA',
            target: '_blank'
        }
    ];
    return (
        <Container>
            <p>Desafio: </p>

            <h2>Conclua o seu PDI e SWOT</h2>

            <span>Faça os testes</span>

            <InfoLogLevel data={data} />
        </Container>
    );
};

Level5LevelModal.propTypes = {
    level: PropTypes.shape(LevelType),
    levelConquered: PropTypes.bool
};

export default Level5LevelModal;
